import React from 'react'
import Step from '../../components/Step'
import Button from '../../elements/Button'
import ButtonContainer from '../../elements/ButtonContainer'
import Input from '../../elements/Input'
import Resi from '../Resi'
import {fieldName, routeName, enforce} from '../HelpersResi'
import HelpIcon from '../../elements/HelpIcon'


const numberOfLots = fieldName('numberOfLots')
    
export const rules = {
    [numberOfLots]: [
        enforce.required("Required"),
        enforce.greaterThanEqual(2)("Number of lots must be at least 2"),
    ]
}

export default () => {
    const navigation = Resi.useNavigation();
    const validation = Resi.useValidation();

    async function next(){
        try{
            await validation.validate(rules)
            navigation.goToNext();
        }catch(e){}
    }

    return (
        <Step>
            <h2>How many lots (apartments/units) are there in your building? <HelpIcon label={numberOfLots} message=""/></h2>
            <div className="row">
                <div className="col-12 col-md-6">
                    <Input autoFocus field={numberOfLots} type="number"/>
                </div>
            </div>
            
            <ButtonContainer>
                <Button label="Continue" icon="fas fa-chevron-right" type="primary" callback={ next } />
            </ButtonContainer>
        </Step>
    )
};
